export const deleteConfirmModalStyles = {
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      border: 'none',
      overflow: 'visible',
    },
  },

  dialogTitle: {
    p: 3,
    pb: 2,
    borderBottom: '1px solid',
  },

  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  titleContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
  },

  warningIcon: {
    fontSize: '24px',
    color: 'error.main',
  },

  titleText: {
    fontWeight: 600,
    color: 'text.primary',
    fontSize: '1.1rem',
  },

  closeButton: {
    color: 'text.secondary',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
  },

  dialogContent: {
    p: 3,
    pt: 2,
  },

  messageText: {
    fontSize: '0.95rem',
    lineHeight: 1.5,
    color: 'text.secondary',
    mb: 2,
  },

  itemNameContainer: {
    borderRadius: '6px',
    p: 1.5,
    mb: 1.5,
    border: 'none',
    textAlign: 'center',
  },

  itemName: {
    fontWeight: 600,
    color: 'text.primary',
    fontSize: '0.95rem',
    mt: 0,
  },

  warningNote: {
    backgroundColor: 'transparent',
    borderRadius: '0px',
    p: 0,
    border: 'none',
    textAlign: 'center',
    mt: 1,
  },

  dialogActions: {
    p: 3,
    pt: 1,
    gap: 1.5,
    justifyContent: 'flex-end',
  },

  cancelButton: {
    minWidth: '100px',
  },

  confirmButton: {
    minWidth: '120px',
    backgroundColor: 'error.main',
    '&:hover': {
      backgroundColor: 'error.dark',
    },
    '&:disabled': {
      backgroundColor: 'error.light',
      color: 'error.contrastText',
      opacity: 0.7,
    },
  },
};

// Theme-aware styles function
export const getDeleteConfirmModalThemeStyles = (theme) => ({
  dialog: {
    ...deleteConfirmModalStyles.dialog,
    '& .MuiDialog-paper': {
      ...deleteConfirmModalStyles.dialog['& .MuiDialog-paper'],
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      boxShadow:
        theme.palette.mode === 'dark'
          ? '0 8px 32px rgba(0, 0, 0, 0.4)'
          : '0 8px 32px rgba(0, 0, 0, 0.12)',
    },
  },
  dialogTitle: {
    ...deleteConfirmModalStyles.dialogTitle,
    borderColor: theme.palette.divider,
  },
  itemNameContainer: {
    ...deleteConfirmModalStyles.itemNameContainer,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.03)',
  },
  cancelButton: {
    ...deleteConfirmModalStyles.cancelButton,
    borderColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.2)'
        : 'rgba(0, 0, 0, 0.12)',
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(0, 0, 0, 0.04)',
      borderColor:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.3)'
          : 'rgba(0, 0, 0, 0.2)',
    },
  },
});
